import React from "react";
import { useBotbRAFContext } from "../context";
import { ReferAFriendInvitePopup } from "@/app/(custom-header)/botb-refer-a-friend/components/ReferAFriendInvitePopup";

function StickyCTA() {
  const { showInviteFriendsPopup, inviteFriendsPopup } = useBotbRAFContext();
  return (
    <>
      <div className="lg:hidden fixed z-[999] bottom-0 !top-auto inset-x-0  shrink-0 bg-white shadow-[0_0_20px_0_rgba(0,0,0,0.20)] px-6 py-2 flex flex-col gap-2 w-full">
        <div>
          <button
            onClick={showInviteFriendsPopup}
            className={"theme-btn theme-btn-primary theme-btn-md uppercase w-full"}>
            Invite friends
          </button>
        </div>
      </div>
      {inviteFriendsPopup && <ReferAFriendInvitePopup />}
    </>
  );
}

export default StickyCTA;
